import { API_BASE_URL } from "src/config/api";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Card,
  CircularProgress,
} from '@mui/material';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

function SubscriptionFormPage(props) {
  SubscriptionFormPage.propTypes = {
    closeForm: PropTypes.func.isRequired,
  };
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    description: '',
  });

  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(`${API_BASE_URL}/getUserById?userId=${userId}`, config);
        const userData = response.data.data;
        setUserData(userData);
        setFormData({
          name: userData.fullName || '',
          email: userData.email || '',
          phoneNumber: userData.phoneNumber || '',
          description: userData.description || '',
        });
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchUser();
  }, [userId, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const urlParts = window.location.pathname.split('/');
      const lastPart = urlParts[urlParts.length - 1];
      if (urlParts.length >= 3 && lastPart) {
        const subsciptionPlanId = lastPart;
        const updatedFormData = {
          ...formData,
          userId,
          subsciptionPlanId,
        };
        const response = await axios.post(
          `${API_BASE_URL}/submitContactSalesForm`,
          updatedFormData,
          config
        );
        setUserData(updatedFormData);
        toast.success(response.data.message);
        props.closeForm();
      } else {
        toast.error('Invalid URL format.');
      }
    } catch (error) {
      console.error('Error submitting form data:', error);
      toast.error('An error occurred while submitting the form.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Card>
      <Container maxWidth="sm" style={{ marginTop: '2rem' }}>
        <Typography variant="h4" gutterBottom>
          Contact Us
        </Typography>
        <Paper elevation={3} style={{ padding: '2rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Full Name"
                  name="name"
                  type="text"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Phone Number"
                  name="phoneNumber"
                  type="text"
                  required
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Description"
                  name="description"
                  multiline
                  minRows={3}
                  required
                  fullWidth
                  value={formData.description}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12}>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                  <>
                    <Button type="submit" variant="contained" color="primary" style={{ marginRight: '1rem' }}>
                      {isLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Submit'}
                    </Button>
                    <Button variant="outlined" color='error' onClick={() => props.closeForm()}>
                      Cancel
                    </Button>
                  </>
                </div>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Container>
    </Card>
  );
}

export default SubscriptionFormPage;
